import * as React from 'react';
import { css, Global } from '@emotion/react';

const GLOBAL_STYLES = css`
    html {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        box-sizing: border-box;
        -webkit-text-size-adjust: 100%;
    }
    body {
        margin: 0;
        color: var(--hc-color-text-body);
        background-color: var(--hc-color-background-body);
        font-family: var(--hc-body-font-family);
        font-weight: var(--hc-body-font-weight-default);
        line-height: var(--hc-base-line-height);
        text-rendering: geometricPrecision;
    }
    *,
    *::before,
    *::after {
        box-sizing: inherit;
    }
    strong,
    b {
        font-weight: var(--hc-body-font-weight-bold);
    }
    ul,
    ol {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
    }
    // Used in storybook docs
    code {
        display: inline-block;
        padding: 0 5px;
        color: var(--hc-color-common-black);
        background-color: var(--hc-color-system-info-lightest);
        border-radius: 5px;
        font-size: 0.8125rem;
        direction: ltr;
    }
`;

export type CssResetProps = {
    /**
     * The content.
     */
    children?: React.ReactNode;
};

export function CssReset(props: CssResetProps): React.JSX.Element {
    const { children } = props;

    return (
        <>
            <Global styles={GLOBAL_STYLES} />
            {children}
        </>
    );
}
